// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AddressSharedStyles from "@ces/App/SharedStyles/LocationPage/LocationAddressStyles";
import { xScreen } from "@ces/XDL/Utilities";
import { customerSelectorStyles } from "@insite/content-library/Components/CustomerSelector";
import { css } from "styled-components";

customerSelectorStyles.pagination = {
    mergeCss: true,
    cssOverrides: {
        pagination: css`
            justify-content: space-between;
            ${xScreen("lte", "md")} {
                flex-wrap: nowrap;
                justify-content: space-between;
            }
        `,
        perPageSelect: css`
            &&& {
                justify-content: flex-start;
            }
        `,
        linkList: css`
            &&& {
                justify-content: flex-end;
            }
        `,
    },
};

customerSelectorStyles.customerCardSelected = customerSelectorStyles.customerCard = {
    address: {
        ...AddressSharedStyles.address,
    },
};
